import { Box, Loader } from "monday-ui-react-core";
import React from "react";

import { useInfiniteScroll } from "./hooks";
import { FlexCenter } from "./table";

export interface InfiniteLoaderProps {
  loading?: boolean;
  hasMore?: boolean;
  loadNextPage: () => void;
}

export function InfiniteLoader({ loading, hasMore, loadNextPage }: InfiniteLoaderProps) {
  const { setElement } = useInfiniteScroll(loadNextPage);
  return (
    <>
      {loading && (
        <FlexCenter>
          <Loader size={Loader.sizes.XS} />
          <Box paddingX={Box.paddingXs.SMALL}>Loading more items...</Box>
        </FlexCenter>
      )}
      {hasMore && !loading && <div ref={setElement} style={{ height: "10px" }} />}
    </>
  );
}
